import { z } from 'zod';

import { BatchBrokerStatusEnum, BatchStatusEnum } from '@e-origin/shared';

export const AdminBatchStatusSchema = z.object({
  value: z.nativeEnum(BatchStatusEnum),
  details: z.string().nullish(),
  subStatus: z.string().nullish(),
  brokerStatus: z.nativeEnum(BatchBrokerStatusEnum).nullish(),
});

export type AdminUpdateBatchStatus = z.infer<typeof AdminBatchStatusSchema>;
